import React, { useState } from "react";
import { Container, Form, Button, Row, Col } from "react-bootstrap";
import Select from "react-select";
import "./FeedbackPage.css";

function FeedbackPage() {
  const [formData, setFormData] = useState({
    typeOfIssue: "Problems With The Site",
    description: "",
    name: "",
    email: "",
    contactNo: "",
  });

  // Select2 Options Format
  const issueOptions = [
    { value: "Problems With The Site", label: "Problems With The Site" },
    { value: "Account Access", label: "Account Access" },
    { value: "Billing/Payment", label: "Billing/Payment" },
    { value: "Other", label: "Other" },
  ];

  // Custom styling matrix for react-select to perfectly mimic Select2 & match the UI
  const customSelectStyles = {
    control: (provided, state) => ({
      ...provided,
      borderColor: state.isFocused ? "#7b42db" : "#cccccc",
      boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(123, 66, 219, 0.15)" : "none",
      "&:hover": {
        borderColor: state.isFocused ? "#7b42db" : "#999999",
      },
      padding: "0.2rem 0.25rem",
      borderRadius: "4px",
      fontSize: "0.95rem",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected 
        ? "#7b42db" 
        : state.isFocused 
        ? "rgba(123, 66, 219, 0.08)" 
        : "#ffffff",
      color: state.isSelected ? "#ffffff" : "#333333",
      fontSize: "0.95rem",
      cursor: "pointer",
      "&:active": {
        backgroundColor: "#7b42db",
      }
    }),
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Submitted Data:", formData);
  };

  return (
    <div className="feedback-page-wrapper py-4 common-modal">
      <div className="text-center feedback-top-header">Feedback</div>

      <Container>
        <div className="form-container mb-5">
          <h2 className="text-start form-title">Report a Bug</h2>

          <Form onSubmit={handleSubmit}>
            {/* Replaced standard Bootstrap select with react-select (Select2 engine) */}
            <Form.Group className="mb-3" controlId="typeOfIssue">
              <Form.Label>Type of Issue</Form.Label>
              <Select
                options={issueOptions}
                styles={customSelectStyles}
                defaultValue={issueOptions[0]}
                isSearchable={true} // Select2 search function match
                onChange={(selectedOption) => 
                  setFormData({ ...formData, typeOfIssue: selectedOption.value })
                }
                classNamePrefix="react-select2"
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="description">
              <Form.Label>Description Of Issue<span className="text-danger">*</span></Form.Label>
              <Form.Control
                as="textarea"
                rows={5}
                required
                value={formData.description}
                onChange={(e) => setFormData({ ...formData, description: e.target.value })}
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="name">
              <Form.Label>Name<span className="text-danger">*</span></Form.Label>
              <Form.Control
                type="text"
                required
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="email">
              <Form.Label>Email<span className="text-danger">*</span></Form.Label>
              <Form.Control
                type="email"
                required
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              />
            </Form.Group>

            <Form.Group className="mb-4" controlId="contactNo">
              <Form.Label>Contact No.</Form.Label>
              <Form.Control
                type="text"
                value={formData.contactNo}
                onChange={(e) => setFormData({ ...formData, contactNo: e.target.value })}
              />
            </Form.Group>

            <p className="info-text mb-4 text-start">
              Please include as many details as possible. This can include the URL of the posting, 
              any related emails and their message headers, actions you've already taken, 
              any responses you've received, etc.
            </p>

            <Button type="submit" className="btn-submit w-100 mb-5">
              Submit
            </Button>
          </Form>
        </div>

        {/* Footer Job Links Grid */}
        <div className="footer-section pt-4 mt-5">
          <Row className="mb-3">
            <Col md={2} className="footer-category-title mb-1 mb-md-0">Jobs by Locations</Col>
            <Col md={10} className="footer-links text-muted">
              : <a href="#">Jobs in Bangalore</a> | <a href="#">Jobs in Delhi</a> | <a href="#">Jobs in Mumbai</a> | <a href="#">Jobs in Chennai</a> | <a href="#">Jobs in Hyderabad</a> | <a href="#">Jobs in Kolkata</a> | <a href="#">Jobs in Pune</a> | <a href="#">Jobs in Chandigarh</a> | <a href="#">Jobs in Lucknow</a> | <a href="#">Jobs in Coimbatore</a> | <a href="#">Jobs in Odisha</a> | <a href="#">Jobs in Jaipur</a> | <a href="#">Jobs in Ahmedabad</a> | <a href="#">Jobs in Indore</a> | <a href="#">Jobs in Nagpur</a> | <a href="#">Jobs in Goa</a> | <a href="#">Jobs in Noida</a> | <a href="#">Jobs in Bhubaneswar</a> | <a href="#">Jobs in Gurgaon</a> | <a href="#">Jobs in Guwahati</a> | <a href="#">Jobs in Dehradun</a> | <a href="#">Jobs in Mysore</a> | <a href="#">Jobs in Bhopal</a> | <a href="#">Jobs in Vijayawada</a>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={2} className="footer-category-title mb-1 mb-md-0">Jobs by Skill - IT</Col>
            <Col md={10} className="footer-links text-muted">
              : <a href="#">Biotechnology Jobs</a> | <a href="#">Digital Marketing Jobs</a> | <a href="#">Graphic Design Jobs</a> | <a href="#">Networking Jobs</a> | <a href="#">Oracle Jobs</a> | <a href="#">SEO Jobs</a> | <a href="#">Software Testing Jobs</a> | <a href="#">Sql Jobs</a> | <a href="#">Web Design Jobs</a>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={2} className="footer-category-title mb-1 mb-md-0">Jobs by Skill - Non IT</Col>
            <Col md={10} className="footer-links text-muted">
              : <a href="#">Accounting Jobs</a> | <a href="#">BPO Jobs</a> | <a href="#">Call Center Jobs</a> | <a href="#">Civil Engineering Jobs</a> | <a href="#">Content Writing Jobs</a> | <a href="#">Electrical Engineering Jobs</a> | <a href="#">Event Management Jobs</a> | <a href="#">Hotel Management Jobs</a> | <a href="#">HR Jobs</a> | <a href="#">Sales Jobs</a>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={2} className="footer-category-title mb-1 mb-md-0">Jobs by Role</Col>
            <Col md={10} className="footer-links text-muted">
              : <a href="#">Air Hostess Jobs</a> | <a href="#">Accountant Jobs</a> | <a href="#">Assistant Professor Jobs</a> | <a href="#">Business Analyst Jobs</a> | <a href="#">Computer Operator jobs</a> | <a href="#">Data Analyst Jobs</a> | <a href="#">Data Entry Operator Jobs</a> | <a href="#">Fashion Designer Jobs</a> | <a href="#">Graphics Designer jobs</a> | <a href="#">Software Engineer Jobs</a>
            </Col>
          </Row>
        </div>
      </Container>
    </div>
  );
}

export default FeedbackPage;